import initialState from "./initial.value";

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "Product_list":
      return { ...state, product_list: action.payload };
    case "Dashbaord_RecentProduct":
      return { ...state, dashboard_recentproduct: action.payload };
    case "Dashbaord_ExpiredProduct":
      return { ...state, dashboard_expiredproduct: action.payload };
    case "Salesdashbaord_ExpiredProduct":
      return { ...state, saleshdashboard_recenttransaction: action.payload };
    case "Brand_list":
      return { ...state, brand_list: action.payload };

    case "Unit_Data":
      return { ...state, unit_data: action.payload };
    case "Variantattribute_Data":
      return { ...state, variantattributes_data: action.payload };
    case "Warranty_Data":
      return { ...state, warranty_data: action.payload };
    case "Barcode_Data":
      return { ...state, barcode_data: action.payload };
    case "Department_Data":
      return { ...state, departmentlist_data: action.payload };
    case "Designation_Data":
      return { ...state, designation_data: action.payload };
    case "Shiftlist_Data":
      return { ...state, shiftlist_data: action.payload };
    case "Attendenceemployee_Data":
      return { ...state, attendenceemployee_data: action.payload };
    case "toggle_header":
      return { ...state, toggle_header: action.payload };
    case "Invoicereport_Data":
      return { ...state, invoicereport_data: action.payload };
    case "Salesreturns_Data":
      return { ...state, salesreturns_data: action.payload };
    case "Quatation_Data":
      return { ...state, quotationlist_data: action.payload };
    case "customer_data":
      return { ...state, customerdata: action.payload };
    case "Userlist_data":
      return { ...state, userlist_data: action.payload };
    case "Rolesandpermission_data":
      return { ...state, rolesandpermission_data: action.payload };
    case "Deleteaccount_data":
      return { ...state, deleteaccount_data: action.payload };
    case "Attendenceadmin_data":
      return { ...state, attendanceadmin_data: action.payload };
    case "Leavesadmin_data":
      return { ...state, leavesadmin_data: action.payload };
    case "Leavestype_data":
      return { ...state, leavetypes_data: action.payload };
    case "Holiday_data":
      return { ...state, holiday_data: action.payload };
    case "Expiredproduct_data":
      return { ...state, expiredproduct_data: action.payload };
    case "Lowstock_data":
      return { ...state, lowstock_data: action.payload };
    case "Categotylist_data":
      return { ...state, categotylist_data: action.payload };
    case "Layoutstyle_data":
      return { ...state, layoutstyledata: action.payload };
    case "Set_Selected_Clients":
      return { ...state, selectedClients: action.payload };
    case "Set_Clients":
      return { ...state, clients: action.payload };
    case "Set_Selected_Brands":
      return { ...state, selectedBrands: action.payload };
    case "LOGIN":
      return {
        ...state,
        auth: {
          token: action.payload.token,
          isAuthenticated: true,
          expirationTime: action.payload.expirationTime,
        },
      };

    case "LOGOUT":
      return {
        ...state,
        auth: {
          token: null,
          isAuthenticated: false,
          expirationTime: null,
        },
        // Clear permissions on logout
        permissions: {
          routes: [],
          role: null,
          hasAllPermissions: false,
          loaded: false,
          page_permissions: {},
        },
      };

    case "SET_PERMISSIONS":
      // console.log("[Reducer] Setting permissions:", action.payload);
      return {
        ...state,
        permissions: {
          routes: action.payload.routes || [],
          role: action.payload.role || null,
          hasAllPermissions: action.payload.hasAllPermissions || false,
          loaded: true,
          page_permissions: action.payload.page_permissions || {},
        },
      };

    case "SET_PROFILE":
      return {
        ...state,
        profile: {
          id: action.payload.id,
          last_login: action.payload.last_login,
          is_superuser: action.payload.is_superuser,
          username: action.payload.username,
          first_name: action.payload.first_name,
          last_name: action.payload.last_name,
          email: action.payload.email,
          is_staff: action.payload.is_staff,
          is_active: action.payload.is_active,
          date_joined: action.payload.date_joined,
          role: action.payload.role,
          phone_number: action.payload.phone_number,
          page_permissions: action.payload.page_permissions,
          client_permissions: action.payload.client_permissions,
          page_authorization: action.payload.page_authorization,
          user_group: action.payload.user_group,
          groups: action.payload.groups,
          user_permissions: action.payload.user_permissions,
        },
      };
    default:
      return state;
  }
};

export default rootReducer;
